import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\GuestHelpController::ask
 * @see app/Http/Controllers/GuestHelpController.php:55
 * @route '/help/account/ask'
 */
export const ask = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ask.url(options),
    method: 'post',
})

ask.definition = {
    methods: ["post"],
    url: '/help/account/ask',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\GuestHelpController::ask
 * @see app/Http/Controllers/GuestHelpController.php:55
 * @route '/help/account/ask'
 */
ask.url = (options?: RouteQueryOptions) => {
    return ask.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\GuestHelpController::ask
 * @see app/Http/Controllers/GuestHelpController.php:55
 * @route '/help/account/ask'
 */
ask.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ask.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\GuestHelpController::ask
 * @see app/Http/Controllers/GuestHelpController.php:55
 * @route '/help/account/ask'
 */
    const askForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: ask.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\GuestHelpController::ask
 * @see app/Http/Controllers/GuestHelpController.php:55
 * @route '/help/account/ask'
 */
        askForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: ask.url(options),
            method: 'post',
        })
    
    ask.form = askForm
const account = {
    ask: Object.assign(ask, ask),
}

export default account